module.exports = __webpack_public_path__ + "static/media/custom-offer.c49bc50d.png";